import React from "react";
import { BiSearch } from "react-icons/bi";
import { FaFacebookMessenger } from "react-icons/fa";
import { FiMenu } from "react-icons/fi";
import { IoMdNotifications } from "react-icons/io";
import avater from "assets/images/avatar.png";
import { useAppContext } from "context/Context";
const Topbar = () => {
  const { toggleSidebar, setToggleSidebar } = useAppContext();
  return (
    <nav className="bg-gray-800 p-1 h-20 grid sticky top-0">
      <div className="flex justify-start sm:justify-between items-center align-middle">
        <div className="flex-1 flex items-center space-x-2 ">
          <img
            className="h-10 w-10 rounded-full object-contain cursor-pointer"
            src="https://freepngimg.com/thumb/facebook/62487-bluetie-icons-computer-facebook-login-icon-email.png"
            alt=""
          />
          <label
            htmlFor="search"
            className="flex justify-start items-center rounded-full  bg-[#3A3B3C] p-3 overflow-hidden "
          >
            <span className="text-lg text-gray-400 cursor-pointer md:mr-2">
              <BiSearch />
            </span>
            <input
              id="search"
              className="  hidden hover:inline-block hover:z-20  md:inline-block  bg-[#3A3B3C] text-xs text-gray-400 outline-none placeholder:text-base placeholder:font-medium"
              type="text"
              placeholder="Search Facebook"
            />
          </label>

          <span
            onClick={() => {
              setToggleSidebar(!toggleSidebar);
            }}
            className=" inline-flex md:hidden mx-2 p-2 rounded-lg text-3xl text-gray-200 hover:bg-gray-500 cursor-pointer"
          >
            <FiMenu />
          </span>
        </div>
        <div className="md:flex-[2] h-full">
          <div className="  z-10  relative hidden md:flex justify-center w-20 items-center h-full border-b-2 border-blue-500  ">
            <div className="relative group  ">
              <div className="group-hover:bg-gray-600 p-2 group-hover:rounded-full transition-all ease-in-out duration-300 flex align-middle">
                <img
                  className="h-8 cursor-pointer"
                  src="https://img.icons8.com/external-kmg-design-flat-kmg-design/32/000000/external-home-ui-essential-kmg-design-flat-kmg-design.png"
                />
              </div>
            </div>
          </div>
        </div>

        <div className=" flex-1 ml-auto flex justify-end sm:w-1/5 ">
          <span className="p-3 mr-2 text-gray-100 bg-gray-700 hover:bg-gray-600 rounded-full text-lg cursor-pointer">
            <FaFacebookMessenger />
          </span>
          <span className="p-3 mr-2 text-gray-100 bg-gray-700 hover:bg-gray-600 rounded-full text-lg cursor-pointer relative">
            <span className="text-white font-medium bg-red-700 rounded-full p-1  text-xs absolute top-[-10px] right-[-2px] shadow-md">
              2
            </span>
            <IoMdNotifications />
          </span>
          <img
            className="h-10 w-10 object-contain rounded-full cursor-pointer"
            src={avater}
          />
        </div>
      </div>
    </nav>
  );
};

export default Topbar;
